import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './NTVMediaHotspotStyle.scss';
import {
  TRAVEL_TIMES,
  ALWAYS_VISIBLE_HOTSPOT_IDS,
  HOTSPOT_RENDER_ORDER,
  getMediaHotspotIcon,
  splitHotspotTitle,
} from './constants';

const NTVMediaHotspotStyle = ({ media }) => {
  const title = media?.title || '';
  const travelTime = TRAVEL_TIMES[media?._id];
  const isSpecialHotspot = ALWAYS_VISIBLE_HOTSPOT_IDS.includes(media?._id);

  // Render order based on HOTSPOT_RENDER_ORDER index
  const renderOrderIndex = HOTSPOT_RENDER_ORDER.indexOf(media?._id);
  const zIndex = renderOrderIndex >= 0 ? renderOrderIndex + 1 : 0;

  //eslint-disable-next-line
  const [isHovered, setIsHovered] = useState(true);

  const { firstLine, secondLine } = splitHotspotTitle(title, media?._id);

  if (isSpecialHotspot) {
    return (
      <div className="ntv-media-hotspot" style={{ zIndex }}>
        <div
          className="ntv-media-hotspot__container"
          style={{ height: `${70 * (media?.height || 1)}px` }}
        >
          <div className={`ntv-media-hotspot__line ${media?._id}`}></div>
          <div
            className="ntv-media-hotspot__title special-hotspot"
            onMouseEnter={() => setIsHovered(false)}
            onMouseLeave={() => setIsHovered(true)}
          >
            <div className="ntv-media-hotspot__title-inner">
              <div className="ntv-media-hotspot__texts-special">
                <div className="ntv-media-hotspot__text-special">Cao ốc</div>
                <div className="ntv-media-hotspot__text-special ntv-media-hotspot__text-special--line2">
                  văn phòng
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const containerClass =
    'ntv-media-hotspot__container ntv-media-hotspot__container--default';

  const SPECIAL_TITLE_IDS = [
    // '6a02dee747b0fda496439303',
    '6a02e02e47b0fda49643944a',
    "6a02ddf547b0fda496438bbb",

    // "6a02dd8f47b0fda4964388e9",

    '690b2e80fbeb572cfafcfaf6',
    '6a02ddda47b0fda496438ad0',
    "6a6c4ef7c6222a78db0fad56"
  ];

  const isSpecialTitle = SPECIAL_TITLE_IDS.includes(media?._id);

  // Center position IDs - title will be centered above the line
  const CENTER_TITLE_IDS = ['6a02dd5447b0fda496438761'];
  const isCenterTitle = CENTER_TITLE_IDS.includes(media?._id);

  const titleClass = `ntv-media-hotspot__title${isSpecialTitle ? ' ntv-media-hotspot__title--offset' : ''}${isCenterTitle ? ' ntv-media-hotspot__title--center' : ''}`;

  const SPECIAL_HEIGHT_IDS = {
    '6a02ded747b0fda496439269': 146,
    '6a02dd6347b0fda4964387bc': 210,
    '6a02dcf447b0fda4964384d7': 130,
    '6a02dd8f47b0fda4964388e9': 108,
    '6a02dd1647b0fda4964385b7': 180,
    '690b2e80fbeb572cfafcfaf6': 100,
    '6a02dd5447b0fda496438761': 165,
    "6a02dee747b0fda496439303" : 161,
    '6a02ddf547b0fda496438bbb': 150,
    // '6a02dd4447b0fda4964386de': 152,
    '6a38ab93163b8b61734dd47d': 170,
    "6a02dd2847b0fda49643861a": 170,
    '6a02dea147b0fda4964390ac': 80,
    '6a38ab03163b8b61734dd3e1': 100,
    '6a38ab52163b8b61734dd437': 100,
    '6a02def847b0fda49643938c': 115,
    "6a02dd0647b0fda496438550" : 138,
    "6a6c4da5c6222a78db0fac47" : 84,
    "6a6c4ef7c6222a78db0fad56" : 184
  };

  const getContainerHeight = () => {
    if (SPECIAL_HEIGHT_IDS[media?._id]) {
      return SPECIAL_HEIGHT_IDS[media?._id];
    }
    return 90 * (media?.height || 1);
  };

  return (
    <div className="ntv-media-hotspot" style={{ zIndex }}>
      <div
        className={containerClass}
        style={{ height: `${getContainerHeight()}px` }}
      >
        <div className={`ntv-media-hotspot__line ${media?._id}`}></div>
        <div
          className={titleClass}
          onMouseEnter={() => setIsHovered(false)}
          onMouseLeave={() => setIsHovered(true)}
        >
          <div className="ntv-media-hotspot__title-inner">
            <div className="ntv-media-hotspot__texts">
              {getMediaHotspotIcon(media?._id) ? (
                <FontAwesomeIcon
                  icon={getMediaHotspotIcon(media?._id)}
                  className="ntv-media-hotspot__icon"
                />
              ) : (
                <span className="ntv-media-hotspot__icon" aria-hidden="true" />
              )}
              <div className="ntv-media-hotspot__texts-inner">
                <div className="ntv-media-hotspot__text">{firstLine}</div>
                {secondLine && (
                  <div className="ntv-media-hotspot__text ntv-media-hotspot__text--line2">
                    {secondLine}
                  </div>
                )}
                {travelTime && (
                  <div className="ntv-media-hotspot__subtitle">
                    {/* {travelTime} */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NTVMediaHotspotStyle;
